/**
 * GLSL for applying screen space effects to computed lighting values inside a three.js physical material shader.
 * @module
 */

export const ssfxParsFragment = `
uniform vec2 renderTargetResolution;
uniform bool ssfxEnabled;

#if defined(SSFX_MATERIAL_DEV) && SSFX_MATERIAL_DEV == 1
uniform int ssfxMaterialOutputType;
#endif

float screenSpaceAo;

#if defined(SSAO) && SSAO == 1 && !defined(DISABLE_SSAO)
uniform sampler2D screenSpaceAoMap;
uniform vec2 aoMapPixelOffset;
uniform vec2 aoMapInvSize;
#endif
#if defined(SSR) && SSR == 1
uniform sampler2D screenSpaceReflectionMap;

// If missing reflection is substituted with irradiance, then this value is used as a multiplier.
uniform float substitutedReflectionMultiplier;

// TODO: Verify that color space gets handled correctly here.
vec4 reflectionTexelToLinear( vec4 value ) {
	return value;
}

#endif

#if (defined(SCREEN_SPACE_SHADOWS) && SCREEN_SPACE_SHADOWS == 1) || (defined(SMALL_SCALE_AO) && SMALL_SCALE_AO == 1)
uniform sampler2D screenSpaceShadowMap;
#endif
`;

export const ssfxFetchFragment = `#if defined(SSAO) && SSAO == 1 && !defined(DISABLE_SSAO)
  vec4 screenSpaceAOFetch = texture2D( screenSpaceAoMap, (gl_FragCoord.xy + aoMapPixelOffset) * aoMapInvSize );
  screenSpaceAo = ssfxEnabled ? screenSpaceAOFetch.r : 1.0;

#if defined(SMALL_SCALE_AO) && SMALL_SCALE_AO == 1
  float screenSpaceShadowMapAO = texture2D(screenSpaceShadowMap, (gl_FragCoord.xy + aoMapPixelOffset) * aoMapInvSize).g;
  screenSpaceAo = ssfxEnabled ? min(screenSpaceAo, screenSpaceShadowMapAO) : 1.0;
#endif
#else
	screenSpaceAo = 1.0;
#endif
`;

// We apply AO to all reflected light since we assume that shadows are not computed for lights.
// The different reflected light values are added together to determine the output color.
export const applySSAO = `#if defined(SSAO) && SSAO == 1 && !defined(DISABLE_SSAO)
	reflectedLight.directDiffuse *= screenSpaceAo;
	reflectedLight.indirectDiffuse *= screenSpaceAo;
	reflectedLight.directSpecular *= screenSpaceAo;
	reflectedLight.indirectSpecular *= screenSpaceAo;
#endif
`;
